/* Typeform-style review form controller */
(function () {
  var root = document.querySelector('[data-form]');
  if (!root) return;

  var form = root.querySelector('[data-tf-form]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
  var progress = root.querySelector('[data-progress]');
  var endpoint = root.getAttribute('data-endpoint') || '';
  var turnstileKey = root.getAttribute('data-turnstile-key') || '';
  var homeUrl = root.getAttribute('data-home') || '/';
  var trustpilotUrl = root.getAttribute('data-trustpilot') || '';
  var current = 0;
  var turnstileWidgetId = null;

  var stepCount = slides.filter(function (s) { return !s.hasAttribute('data-thanks'); }).length;

  function setProgress() {
    var pct = Math.min(100, Math.round((current / (stepCount - 1)) * 100));
    if (progress) progress.style.width = pct + '%';
  }

  function focusSlide(slide) {
    var field = slide.querySelector('.tf__input, .tf__check input, [data-next], [data-submit]');
    if (field) { try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); } }
  }

  function go(index) {
    if (index < 0 || index >= slides.length || index === current) return;
    var from = slides[current];
    var to = slides[index];
    from.classList.add('is-leaving');
    setTimeout(function () {
      from.classList.remove('is-active', 'is-leaving');
      to.classList.add('is-active');
      current = index;
      setProgress();
      focusSlide(to);
      if (to.querySelector('[data-turnstile-mount]')) mountTurnstile();
    }, from.classList.contains('is-active') ? 320 : 0);
  }

  function clearError(slide) {
    var e = slide.querySelector('[data-error]');
    if (e) e.textContent = '';
  }
  function showError(slide, msg) {
    var e = slide.querySelector('[data-error]');
    if (e) e.textContent = msg;
  }

  function validate(slide) {
    clearError(slide);
    if (!slide.hasAttribute('data-required')) return true;
    var field = slide.getAttribute('data-field');

    if (field === 'rating') {
      var rv = slide.querySelector('[data-rating-value]');
      if (!rv.value) { showError(slide, 'Izaberi ocenu.'); return false; }
      return true;
    }
    if (field === 'consent') {
      var cb = slide.querySelector('input[type=checkbox]');
      if (!cb.checked) { showError(slide, 'Potrebna je tvoja saglasnost.'); return false; }
      return true;
    }
    var input = slide.querySelector('.tf__input');
    if (input) {
      var val = (input.value || '').trim();
      if (!val) { showError(slide, 'Ovo polje je obavezno.'); return false; }
      var min = parseInt(slide.getAttribute('data-min') || '0', 10);
      if (min && val.length < min) { showError(slide, 'Napiši bar ' + min + ' karaktera (trenutno ' + val.length + ').'); return false; }
    }
    return true;
  }

  function next() {
    var slide = slides[current];
    // validate optional url field if filled
    if (slide.getAttribute('data-field') === 'video_url') {
      var u = slide.querySelector('input[name=video_url]');
      if (u && u.value.trim() && !/^https?:\/\//i.test(u.value.trim())) {
        showError(slide, 'Link mora počinjati sa http:// ili https://'); return;
      }
    }
    if (!validate(slide)) return;
    go(current + 1);
  }

  // ---- Star input ----
  var starWrap = root.querySelector('[data-star-input]');
  if (starWrap) {
    var stars = Array.prototype.slice.call(starWrap.querySelectorAll('[data-star]'));
    var ratingInput = root.querySelector('[data-rating-value]');
    function paint(n) { stars.forEach(function (s) { s.classList.toggle('is-on', parseInt(s.getAttribute('data-star'), 10) <= n); }); }
    stars.forEach(function (s) {
      var n = parseInt(s.getAttribute('data-star'), 10);
      s.addEventListener('mouseenter', function () { paint(n); });
      s.addEventListener('click', function () {
        ratingInput.value = n; paint(n);
        clearError(slides[current]);
        setTimeout(next, 320);
      });
    });
    starWrap.addEventListener('mouseleave', function () { paint(parseInt(ratingInput.value || '0', 10)); });
  }

  // ---- Choice pills (course): supports single or multi select ----
  var choiceWrap = root.querySelector('[data-choices]');
  if (choiceWrap) {
    var multi = choiceWrap.hasAttribute('data-multi');
    var courseInput = root.querySelector('[data-course-value]');
    var otherInput = root.querySelector('[data-other-input]');
    var otherBtn = choiceWrap.querySelector('[data-choice-other]');
    var choices = Array.prototype.slice.call(choiceWrap.querySelectorAll('[data-choice]'));

    function syncCourse() {
      var vals = choices.filter(function (c) { return c.classList.contains('is-on'); })
        .map(function (c) { return c.getAttribute('data-choice'); });
      if (otherBtn && otherBtn.classList.contains('is-on') && otherInput && otherInput.value.trim()) {
        vals.push(otherInput.value.trim());
      }
      courseInput.value = vals.join(', ');
    }

    choices.forEach(function (c) {
      c.addEventListener('click', function () {
        if (multi) {
          c.classList.toggle('is-on');
        } else {
          choices.forEach(function (x) { x.classList.remove('is-on'); });
          if (otherBtn) otherBtn.classList.remove('is-on');
          if (otherInput) otherInput.hidden = true;
          c.classList.add('is-on');
        }
        syncCourse();
        if (!multi) setTimeout(next, 260);
      });
    });

    if (otherBtn && otherInput) {
      otherBtn.addEventListener('click', function () {
        if (!multi) choices.forEach(function (x) { x.classList.remove('is-on'); });
        otherBtn.classList.toggle('is-on');
        otherInput.hidden = !otherBtn.classList.contains('is-on');
        if (!otherInput.hidden) otherInput.focus();
        syncCourse();
      });
      otherInput.addEventListener('input', syncCourse);
    }
  }

  // ---- Skool profile autofill ----
  var skoolBtn = root.querySelector('[data-skool-fetch]');
  if (skoolBtn) {
    var skoolInput = root.querySelector('[data-skool-input]');
    var skoolStatus = root.querySelector('[data-skool-status]');
    var skoolPreview = root.querySelector('[data-skool-preview]');
    var skoolAvatar = root.querySelector('[data-skool-avatar]');
    var skoolName = root.querySelector('[data-skool-name]');
    var photoUrlInput = root.querySelector('[data-photo-url]');
    var nameInput = form.querySelector('input[name=reviewer_name]');

    skoolBtn.addEventListener('click', function () {
      var url = (skoolInput.value || '').trim();
      if (!url) { skoolStatus.textContent = 'Zalepi link prvo.'; return; }
      if (!/skool\.com/i.test(url)) { skoolStatus.textContent = 'To nije Skool link.'; return; }
      if (!endpoint) { skoolStatus.textContent = 'Forma nije povezana.'; return; }
      skoolBtn.classList.add('is-loading');
      skoolStatus.textContent = 'Učitavam…';
      fetch(endpoint.replace(/\/$/, '') + '/skool?url=' + encodeURIComponent(url))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          skoolBtn.classList.remove('is-loading');
          if (!d || d.ok !== true || (!d.name && !d.avatar)) {
            skoolStatus.textContent = 'Nismo uspeli da učitamo profil. Popuni ručno.';
            return;
          }
          skoolStatus.textContent = 'Učitano ✓';
          if (d.name && nameInput) nameInput.value = d.name;
          if (d.avatar && photoUrlInput) photoUrlInput.value = d.avatar;
          if (d.avatar && skoolAvatar) skoolAvatar.src = d.avatar;
          if (skoolName) skoolName.textContent = d.name || '';
          if (skoolPreview) skoolPreview.hidden = false;
        })
        .catch(function () {
          skoolBtn.classList.remove('is-loading');
          skoolStatus.textContent = 'Greška pri učitavanju. Popuni ručno.';
        });
    });
  }

  // ---- Buttons ----
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-next], [data-back], [data-skip], [data-submit]');
    if (!t) return;
    if (t.hasAttribute('data-next')) next();
    else if (t.hasAttribute('data-back')) go(current - 1);
    else if (t.hasAttribute('data-skip')) go(current + 1);
    else if (t.hasAttribute('data-submit')) submit(t);
  });

  // ---- Keyboard ----
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'textarea' && !(e.metaKey || e.ctrlKey)) return; // allow newlines
    if (e.target.closest('[data-submit]')) return;
    e.preventDefault();
    var slide = slides[current];
    if (slide.querySelector('[data-submit]')) submit(slide.querySelector('[data-submit]'));
    else next();
  });

  // ---- Turnstile ----
  function mountTurnstile() {
    if (!turnstileKey) return;
    var mount = root.querySelector('[data-turnstile-mount]');
    if (!mount || turnstileWidgetId !== null) return;
    function render() {
      if (!window.turnstile) return false;
      turnstileWidgetId = window.turnstile.render(mount, { sitekey: turnstileKey });
      return true;
    }
    if (!render()) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      s.async = true; s.defer = true;
      s.onload = render;
      document.head.appendChild(s);
    }
  }

  // ---- Submit ----
  function gather() {
    var data = {};
    Array.prototype.slice.call(form.querySelectorAll('[name]')).forEach(function (el) {
      if (el.type === 'checkbox') { data[el.name] = el.checked ? 'yes' : ''; }
      else { data[el.name] = (el.value || '').trim(); }
    });
    return data;
  }

  function submit(btn) {
    var slide = slides[current];
    if (!validate(slide)) return;
    var payload = gather();

    if (turnstileKey) {
      var token = window.turnstile && turnstileWidgetId !== null ? window.turnstile.getResponse(turnstileWidgetId) : '';
      if (!token) { showError(slide, 'Potvrdi da nisi robot.'); return; }
      payload.turnstile_token = token;
    }

    if (!endpoint) { showError(slide, 'Forma još nije povezana (nedostaje endpoint).'); return; }

    btn.classList.add('is-loading');
    btn.textContent = 'Šalje se…';

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.body || res.body.ok !== true) {
          throw new Error((res.body && res.body.error) || 'Greška pri slanju.');
        }
        var thanks = slides.filter(function (s) { return s.hasAttribute('data-thanks'); })[0];
        if (thanks) go(slides.indexOf(thanks));
        if (progress) progress.style.width = '100%';
        if (trustpilotUrl) {
          try { if (navigator.clipboard && payload.body) navigator.clipboard.writeText(payload.body); } catch (e) {}
          var tlink = root.querySelector('[data-trustpilot-link]');
          var tnote = root.querySelector('[data-trustpilot-note]');
          if (tlink) {
            var sep = trustpilotUrl.indexOf('?') > -1 ? '&' : '?';
            tlink.href = trustpilotUrl + (payload.reviewer_name ? sep + 'name=' + encodeURIComponent(payload.reviewer_name) : '');
            tlink.hidden = false;
          }
          if (tnote) tnote.hidden = false;
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = 'Pošalji utisak';
        showError(slide, err.message || 'Došlo je do greške. Pokušaj ponovo.');
        if (turnstileKey && window.turnstile && turnstileWidgetId !== null) window.turnstile.reset(turnstileWidgetId);
      });
  }

  // ---- Home link respects theme routes ----
  var homeLink = root.querySelector('[data-home-link]');
  if (homeLink) homeLink.setAttribute('href', homeUrl);

  setProgress();
})();
